export default __webpack_public_path__ + "static/rappe-niemirska-3fcd6380293f6e45ea99de6573087f68.jpg";